<div class="login-container flex h-full w-full flex-col">
  <pr-navbar />
  <div class="m-auto">
    <mat-card appearance="outlined">
      <mat-card-content>
        <ng-content />
      </mat-card-content>
    </mat-card>
  </div>
</div>
